import { bsc, bscTestnet, mainnet, MainnetSupported, sepolia, SupportedChainId, TestnetSupported } from './AppSupportChains';

export interface AppTokenWhitelistItem {
  address: `0x${string}`;
  symbol: string;
  chainIds: SupportedChainId[];
}

export const NativeAddress = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';

const allSupportedTestChainIds = [sepolia.id, bscTestnet.id, mainnet.id, bsc.id];

const AppTokenWhitelist: AppTokenWhitelistItem[] = [{ address: NativeAddress, symbol: '', chainIds: allSupportedTestChainIds }];

console.log('TestnetSupported', TestnetSupported);
console.log('MainnetSupported', MainnetSupported);
if (TestnetSupported) {
  AppTokenWhitelist.push(
    { address: '0xb029bef3928C98Db598Cf2941110BFEb18066206', symbol: 'tUSDT', chainIds: allSupportedTestChainIds },
    { address: '0xA0509d3d6833B380Ba387f890BbD70b96DA586C4', symbol: 'tUSDC', chainIds: allSupportedTestChainIds },
  );
}

// if (MainnetSupported) {
//   AppTokenWhitelist.push(
//     { address: '0xdAC17F958D2ee523a2206206994597C13D831ec7', symbol: 'USDT', chainIds: [mainnet.id] },
//     { address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', symbol: 'USDC', chainIds: [mainnet.id] },

//     { address: '0x55d398326f99059fF775485246999027B3197955', symbol: 'USDT', chainIds: [bsc.id] },
//     { address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d', symbol: 'USDC', chainIds: [bsc.id] },
//   );
// }

export default AppTokenWhitelist;
